import { lowerFirst } from 'lodash';
import {api} from '../../api';
import * as React from "react";
import {observable} from "mobx";

export class CrudComponent extends React.Component<any> {
    modelName: string;
    api: any;
    @observable isLoading = true;

    constructor(props: any) {
        super(props);

        this.resolveModule().then((module) => {
            this.api = api[lowerFirst(this.modelName)];
            this.load(props, module);
        });
    }

    resolveModule() {
        return Promise.resolve(import('../pages/' + this.modelName + 'Page'));
    }

    load(props: any, module: any) {

    }

    render() {
        if (this.isLoading) {
            return <div>Loading ...</div>;
        }

        return null;
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/crud/CrudComponent.tsx